import axios from 'axios';
import config from '../config/config';
import { refreshAccessToken } from './tokenRefresh';

const FALLBACK_CONFIG = {
  api: { baseURL: 'http://localhost:5000/api', timeout: 30000 },
  auth: { tokenKey: 'authToken', refreshTokenKey: 'refreshToken', userKey: 'user' },
  app: { loginRoute: '/login' },
};

// Используем config или fallback
const currentConfig = config || FALLBACK_CONFIG;

const axiosInstance = axios.create({
  baseURL: currentConfig.api.baseURL,
  timeout: currentConfig.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерцептор для добавления токена к каждому запросу
axiosInstance.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem(currentConfig.auth.tokenKey);
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ответов и ошибок
axiosInstance.interceptors.response.use(
  (response) => {
    // Логируем только важные запросы, чтобы не засорять консоль
    const url = response.config.url || '';
    // Не логируем успешные запросы к аватарам и другим медиа
    if (!url.includes('/avatar') && !url.includes('/cover') && !url.includes('/wall-posts/feed')) {
      console.log('axiosInstance: получен ответ:', url, 'статус:', response.status);
    }
    return response;
  },
  async (error) => {
    const url = error.config?.url || '';
    const status = error.response?.status;
    
    // Не логируем 404 для аватаров/обложек - это нормальная ситуация (аватар может отсутствовать)
    if (status === 404 && (url.includes('/avatar') || url.includes('/cover'))) {
      // Тихо обрабатываем 404 для медиа - это не ошибка, а нормальная ситуация
      return Promise.reject(error);
    }
    
    console.log('axiosInstance: ошибка запроса:', url, 'статус:', status, 'ошибка:', error.message);
    const originalRequest = error.config;

    // Если 401 и не запрос на refresh/login (чтобы не зациклиться)
    if (status === 401 && !originalRequest._retry &&
        !url.includes('/auth/refresh') && !url.includes('/auth/login')) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        delete axiosInstance.defaults.headers.common['Authorization'];
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
